{
  "date": {
    "id": "date",
    "name": "Request Date",
    "dataType": "date",
    "operators": ["before", "after"],
    "description": "The date the request was made."
  },
  "day_of_week": {
    "id": "day_of_week",
    "name": "Day of Week",
    "dataType": "day_of_week",
    "operators": [],
    "description": "Day of week, uses cronjob like syntax"
  },
  "domain": {
    "id": "domain",
    "name": "Domain",
    "dataType": "string_matcher",
    "operators": [
      "is",
      "contains",
      "ends_with",
      "starts_with",
      "not",
      "in",
      "not_in"
    ],
    "description": "The domain"
  },
  "email": {
    "id": "email",
    "name": "Email",
    "dataType": "string_matcher",
    "operators": [
      "is",
      "contains",
      "ends_with",
      "starts_with",
      "not",
      "in",
      "not_in"
    ],
    "description": "Email"
  },
  "user": {
    "id": "user",
    "name": "User ID",
    "dataType": "string_matcher",
    "operators": [
      "is",
      "contains",
      "ends_with",
      "starts_with",
      "not",
      "in",
      "not_in"
    ],
    "description": "User ID"
  },
  "time_of_day": {
    "id": "time_of_day",
    "name": "Time of Day",
    "dataType": "time_of_day",
    "operators": ["after", "before"],
    "description": "Time of Day of the Request"
  },
  "claim": {
    "id": "claim",
    "name": "Claim",
    "dataType": "string_matcher",
    "operators": [],
    "description": "Family Name in the claim matches."
  },
  "http_method": {
    "id": "http_method",
    "name": "HTTP Method",
    "dataType": "string_matcher",
    "operators": ["is", "not", "in", "not_in"],
    "description": "POST, GET, PUT, DELETE, PATCH, OPTIONS, TRACE, CONNECT"
  },
  "http_path": {
    "id": "http_path",
    "name": "HTTP Path",
    "dataType": "string_matcher",
    "operators": [
      "is",
      "contains",
      "ends_with",
      "starts_with",
      "not",
      "in",
      "not_in"
    ],
    "description": "Matches an Http Path"
  },
  "client_certificate": {
    "id": "client_certificate",
    "name": "Client Certificate",
    "dataType": "client_certificate",
    "operators": [
      "fingerprint",
      "spki_hash",
      "san_dns",
      "san_email",
      "san_uri"
    ],
    "description": "Match based on Client Certificate"
  },
  "ssh": {
    "id": "ssh",
    "name": "SSH",
    "operators": []
  },
  "mcp_tool": {
    "id": "mcp_tool",
    "name": "MCP Tool",
    "operators": [
      "is",
      "not",
      "contains",
      "ends_with",
      "starts_with",
      "in",
      "not_in"
    ]
  },
  "source_ip": {
    "id": "source_ip",
    "name": "Source IP",
    "operators": []
  }
}
